import { render, staticRenderFns } from "./AcoesReclassificar.vue?vue&type=template&id=86c9db6a&scoped=true"
import script from "./AcoesReclassificar.vue?vue&type=script&lang=js"
export * from "./AcoesReclassificar.vue?vue&type=script&lang=js"
import style0 from "./AcoesReclassificar.vue?vue&type=style&index=0&id=86c9db6a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c9db6a",
  null
  
)

export default component.exports